import { Box, Flex, Tabs } from "@mantine/core";
import { useState } from "react";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import COD from "./COD";
import RequestTransferExpress from "./RequestTransferExpress";

const ListTabCOD = () => {
  const [activeTab, setActiveTab] = useState<string | null>("order");
  // Chỗ đặt nút Làm mới / Export Excel, cùng hàng với breadcrumb. Chỉ tab đang mở được render
  // nên nút luôn thuộc về tab đó, export ra đúng dữ liệu của tab
  const [toolbar, setToolbar] = useState<HTMLDivElement | null>(null);

  return (
    <>
      <Flex justify="space-between" align="center">
        <_breadcrumb></_breadcrumb>
        <div ref={setToolbar} />
      </Flex>
      <Tabs value={activeTab} onChange={setActiveTab}>
        <Tabs.List grow>
          <Tabs.Tab value="order">Đơn hàng COD</Tabs.Tab>
          <Tabs.Tab value="requestTransfer">Đơn điều chuyển</Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel value="order">
          {activeTab === "order" ? <COD toolbar={toolbar} /> : <></>}
        </Tabs.Panel>
        <Tabs.Panel value="requestTransfer">
          {activeTab === "requestTransfer" ? (
            <RequestTransferExpress toolbar={toolbar} />
          ) : (
            <></>
          )}
        </Tabs.Panel>
      </Tabs>
    </>
  );
};

export default ListTabCOD;
